/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { BaseClient } from "@emt/emt-http-base-client";
import { Metadata } from "@emt/emt-metadata-client";
import { getBaseUri, getDefaultRequestInit } from "../utilities/client-helper";

const baseUrl = `${getBaseUri()}/dashboard/incentives/enrollment/api`;
const metadataUrl = `${baseUrl}/v2.0/metadata`;

/**
 * HTTP client that talks to the Enrollment service's own ExternalMetadataController
 * endpoint instead of calling the unauthenticated Metadata service directly.
 */
export class EnrollmentMetadataClient extends BaseClient {
    async getMetaData(locale?: string): Promise<Metadata> {
        const url = locale
            ? `${metadataUrl}?locale=${encodeURIComponent(locale)}`
            : metadataUrl;

        return this.fetch<Metadata>(url, undefined, await getDefaultRequestInit(false, true));
    }
}
